module.exports = __webpack_public_path__ + "img/ts15.71b5afa7.png";